module.exports = __webpack_public_path__ + "img/home_icon_loupan_default.82fc4eb4.png";